<div [formGroup]="group">
    <div *ngFor="let remark of group.controls; let i=index;" class="sep-top">
        <div [formGroupName]="i" class="sep-top">
            <textarea-field [group]="group.controls[i]" controlName="text"></textarea-field>
        </div>
    </div>
</div>
